// extracted by extract-css-chunks-webpack-plugin
module.exports = {"star":"_1TR9s6"};